import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";

export type LegalDocument = {
  id: number | null;
  client_name: string;
  client_email: string;
  pa_name: string;
  pa_email: string;
  client_uid: string;
  document_type: string | null;
  sent_date: string | null;
  signed_date: string | null;
  doc_link: string | null;
  pdf_s3_key: string | null;
  original_filename: string | null;
  pdf_url: string | null;
  pa_uid: string | null;
  created_at: string | null;
  updated_at: string | null;
};

export type LegalDocumentsResponse = LegalDocument[];

/**
 * Every client of a PA, with their legal document if one exists (the outer join
 * means a client with no document still comes back, with `id: null`).
 *
 * Errors are deliberately NOT swallowed — see the note on `useHistoricPayments`.
 * A `catch { return null }` here rendered a failed request as "0/6 — nothing on
 * file yet", which reads as fact rather than failure.
 */
export function useLegalDocuments(uid: string | undefined) {
  return useQuery<LegalDocumentsResponse, Error>({
    queryKey: ["legal_documents", uid],
    enabled: !!uid,
    queryFn: async () => {
      const res = await apiRequest(
        "GET",
        `/legal_documents/legal-documents/pa/${uid}`,
      );
      return res.json();
    },
  });
}
